<template>
  <v-container class="px-4">
    <h1 style="font-family: 'montserrat-semibold';">Alerts</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
          @click="dialogCreateAlert = true, getRate('USD', 'MXN')"
          :disabled="!permissionList.includes('createAlert') || loading"
        >
          {{ "Create alert" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="loading" />
    <v-data-table class="d-none d-sm-block" :items-per-page="5" v-else hide-default-header :items="alerts" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Alertas activas" }}</th>                                                                                                                                                                                  
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">
              <div style="display: inline-flex; align-items: center;">
                <v-img
                  src="../../assets/icons/usa-mex.png"
                  alt="usd-mxn"
                  style="width: 26px; height: 16px; margin-right: 20px; object-fit: contain;"
                ></v-img>
                <span style="color: #2D2D2D; font-weight: 400;">1 USD = {{ item.dAmount }} MXN</span>
              </div>
            </td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-if="dialogCreateAlert" v-model="dialogCreateAlert" persistent class="pa-8" max-width="450">
      <v-card>
        <v-card-title class="pl-16" style="color: #193D6E; font-weight: bold">
          <span style="font-size: 24px;">{{ 'Crear alerta' }}</span>
        </v-card-title>
        <v-card-subtitle class="pl-16 pt-2">
          <v-icon color="#12A150">mdi-trending-up</v-icon> <span style="color: #12A150;">1 USD = {{ exchangeRateToday ? exchangeRateToday : 0 }} MXN</span>
        </v-card-subtitle>
        <v-card-text>
         <v-container class="d-flex justify-center" style="color: black; font-size: 16px; font-weight: 500;">
          {{ 'Notificarme cuando el precio de USD llegue a' }}
         </v-container>

         <v-container class="d-flex justify-center px-12">
          <v-text-field
            type="number"
            v-model="targetPrice"
            color="black"
            solo
            :suffix="'Precio objetivo'"
            class="mb-5"
            style="border-radius: 10px; color: #737583;"
            hide-spin-buttons
            :autofocus="false"
          >
            <template #prepend-inner>
              <img src="../../assets/images/mx-flag.png" alt="Custom Icon" style="width: 26px; height: 20px;" />
            </template>
          </v-text-field>
         </v-container>

         <v-container class="d-flex justify-center">
          <v-row class="d-flex justify-center">
            <v-col class="d-flex justify-center">
              <v-btn color="#FFFFFF" rounded class="d-flex align-center" @click="dialogCreateAlert = false, targetPrice = null, isLoadingAlertsCreate = false" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;">
                <span style="color: black; text-transform: none; font-size: 16px;">{{ 'Cancelar' }}</span>
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-center">
              <v-btn
              color="black"
              rounded
              class="d-flex align-center"
              @click="createAlert()"
              :loading="isLoadingAlertsCreate || isLoadingRate"
              style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); width: 150px;"
            >
              <template v-slot:loader>
                <v-progress-circular
                  indeterminate
                  :size="20"
                  style="color: white;"
                ></v-progress-circular>
              </template>
              <span style="color: white; text-transform: none; font-size: 16px;">{{ 'Crear' }}</span>
            </v-btn>
            </v-col>
          </v-row>
         </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Alerts",
    props: {
      activeTab: String,
      enterprise: Object,
      permissionList: Array,
    },
    data() {
      return {
        alerts: [],
        exchangeRateToday: "",
        loading: false,
        dialogCreateAlert: false,
        isLoadingRate: false,
        targetPrice: null,
        isLoadingAlertsCreate: false,
      }
    },
    watch: {
      activeTab(val) {
        if (val === 'alerts') {
          this.getAlerts();
        }
      }
    },
    mounted() {
      if (this.activeTab === 'alerts') {
        this.getAlerts();
      }
    },
    methods: {
      getAlerts() {
        this.loading = true;
        this.alerts = [];

        DB.get(`${URI}/api/v1/en/administrator/alerts/${this.$route.params.sEnterpriseId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.alerts = response.data.alerts;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      createAlert() {
        this.isLoadingAlertsCreate = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          dAmount: this.targetPrice,
          dAmountSpot: this.exchangeRateToday,
          sType: "8e574e88-2670-469e-b96e-7091082d82b9"
        };
        DB.post(`${URI}/api/v1/en/administrator/createAlert`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.mixSuccess(response.data.message);
          this.getAlerts();
          this.isLoadingAlertsCreate = false;
          this.dialogCreateAlert = false;
          this.targetPrice = null;
        })
        .catch((error) => {
          this.isLoadingAlertsCreate = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      async getRate(originCurrency, destCurrency) {
        this.isLoadingRate = true;
        this.exchangeRateToday = null;
        this.exchangeRateTodayReference = null;
        this.amounts = { USD: 0, MXN: 0 };

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          currency: originCurrency,
          desCurrency: destCurrency,
        };

        if (originCurrency != destCurrency) {
          DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
          .then((response) => {
            this.exchangeRateToday = response.data.exchangeRateToday;
            this.exchangeRateTodayReference = response.data.exchangeRateTodayReference;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        }
      },
    }
  }
</script>
<style scoped>
</style>